import { usePushNotifications } from '@/hooks/usePushNotifications';
import { useAppLinks } from '@/hooks/useAppLinks';
import { useNativePlatform } from '@/hooks/useNativePlatform';

/**
 * Mounts push notification listeners and native platform setup for the
 * entire authenticated session.
 *
 * Renders nothing — exists solely to host hooks:
 * - `usePushNotifications`: foreground toasts, tap-to-navigate, token refresh
 * - `useAppLinks`: Android App Links deep link navigation
 * - `useNativePlatform`: back button, status bar, keyboard, splash screen
 *
 * Push registration is prompted after a user's first loan creation, not here.
 * See useCreateLoan in src/hooks/useLoans.ts.
 *
 * Must be rendered inside both <BrowserRouter> (for useNavigate) and
 * <AuthProvider> (for useAuth). Placed in App.tsx alongside AuthQuerySync.
 */
export function PushNotificationProvider() {
  // Attach all Capacitor push notification listeners (single mount point).
  usePushNotifications();

  // Attach App Link listener for deep link navigation (Android App Links).
  useAppLinks();

  // One-time native platform setup (back button, status bar, keyboard, splash).
  useNativePlatform();

  return null;
}
